<div class="container-fluid page">
  <div class="page-content shadow position-relative">
    <mat-tab-group>
      <mat-tab label="Users List">
        <ng-template matTabContent>
          <div class="px-4">
            <div class="d-flex justify-content-start pt-1 my-1">
              <form
                [formGroup]="filterForm"
                class="mat-form d-flex align-items-center gap-10">
                <app-input-select
                  *appHasPlatformAccess
                  (selectionChange)="applyFilter()"
                  [inputData]="attrConstant.partner"
                  [selectOptions]="partnerList | async"
                  [bindLabel]="'name'"
                  [bindValue]="'partner_id'"
                  [formControlName]="
                    attrConstant.partner.key
                  "></app-input-select>
                <app-input-template
                  (keyup)="applyFilter()"
                  [inputData]="attrConstant.search"
                  [formControlName]="
                    attrConstant.search.key
                  "></app-input-template>
                <img
                  src="assets/images/clear-filter.svg"
                  class="clear-img"
                  alt="clear-filter"
                  matTooltip="Clear Filters"
                  matTooltipPosition="above"
                  [attr.aria-hidden]="true"
                  (click)="clearFilters()" />
              </form>
            </div>
            <table
              mat-table
              matSort
              [matSortActive]="activeSort?.active ?? 'created_at'"
              [matSortDirection]="activeSort?.direction ?? 'desc'"
              [dataSource]="dataSource"
              (matSortChange)="onSortChange($event)">
              <!-- Name Column -->
              <ng-container matColumnDef="first_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let element" data-label="Name">
                  {{ element.first_name }} {{ element.last_name }}
                </td>
              </ng-container>

              <!-- Email Column -->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let element" data-label="Email">
                  {{ element.email }}
                </td>
              </ng-container>

              <!-- User Type Column -->
              <ng-container matColumnDef="role_type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  User Type
                </th>
                <td mat-cell *matCellDef="let element" data-label="Role">
                  {{ element.role_type }}
                </td>
              </ng-container>

              <!-- Role Name Column -->
              <ng-container matColumnDef="role_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Role Name
                </th>
                <td mat-cell *matCellDef="let element" data-label="Role">
                  {{ element.role_name }}
                </td>
              </ng-container>

              <!-- Action Column -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>
                  <ng-container
                    *appHasAccess="'/user-management/user/edit/:id'">
                    Action
                  </ng-container>
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Action"
                  (click)="$event.stopPropagation()">
                  <div class="d-flex align-items-center action-gap-10">
                    <img
                      src="assets/images/edit-icon.svg"
                      alt="edit-icon"
                      matTooltip="Edit"
                      matTooltipPosition="left"
                      [routerLink]="[
                        '/user-management/user/edit',
                        isSuperAdmin
                          ? element.user_id + '-' + element.partner_id
                          : element.user_id,
                      ]"
                      *appHasAccess="'/user-management/user/edit/:id'" />
                    <img
                      src="assets/images/delete-icon.svg"
                      alt="delete-icon"
                      matTooltip="Delete"
                      matTooltipPosition="right"
                      [attr.aria-hidden]="true"
                      (click)="
                        onDeleteUser(element.user_id, element.partner_id)
                      "
                      *appHasAccess="'delete-user'" />
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                class="custom-mat-btn"
                *matRowDef="
                  let row;
                  columns: displayedColumns;
                  let element
                "></tr>
            </table>
            <mat-paginator
              showFirstLastButtons
              [pageIndex]="page"
              [length]="total"
              [pageSize]="limit"
              [pageSizeOptions]="[10, 20, 50, 100, 200]"
              (page)="onPageChange($event)">
            </mat-paginator>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab disabled *appHasAccess="'/user-management/user/add'">
        <ng-template mat-tab-label>
          <a
            class="btn primary-btn"
            [routerLink]="['/user-management/user/add']">
            Add Users
          </a>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
